window.addEventListener('DOMContentLoaded', () => {
    let mobileColumnHeadingAdded = false;
    // get .lookeen__price-comparison-table
    const priceComparisonTable = document.querySelector('.lookeen__price-comparison-table');
    if(!priceComparisonTable) return;

    // get lookeen__price-comparison-table-head-cell text content
    const priceComparisonTableHeadCells = document.querySelectorAll('.lookeen__price-comparison-table-head-cell');
    if(!priceComparisonTableHeadCells) return;

    // get text content of each lookeen__price-comparison-table-head-cell
    const priceComparisonTableHeadCellsText = Array.from(priceComparisonTableHeadCells).map(cell => cell.textContent);
    if(!priceComparisonTableHeadCellsText) return;

    // remove empty string from the array
    // slice the array to remove the first element
    const priceComparisonTableHeadCellsTextFiltered = priceComparisonTableHeadCellsText.filter(cell => cell !== '').slice(1);
    if(!priceComparisonTableHeadCellsTextFiltered) return;

    console.log(priceComparisonTableHeadCellsTextFiltered);

    

    // check if the media query matches
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    if(mediaQuery.matches) {
        addTableMobileColumnHeadings();
    } else {
        // remove the mobile column headings

        // removeTableMobileColumnHeadings();

    }

    // on window resize check if the media query matches
    window.addEventListener('resize', () => {
        if(mediaQuery.matches) {
            addTableMobileColumnHeadings();
        } else {
           
            // remove the mobile column headings
            // removeTableMobileColumnHeadings();
        }
    });


    function addTableMobileColumnHeadings(){
        if(mobileColumnHeadingAdded) return;
        mobileColumnHeadingAdded = true;
        // construct the table head
        const tableHead = document.createElement('div');
        tableHead.classList.add('lookeen__price-comparison-table-head-mobile');
        // append all text content to the table head
        priceComparisonTableHeadCellsTextFiltered.forEach(cell => {
            const cellElement = document.createElement('div');
            cellElement.classList.add('lookeen__price-comparison-table-head-cell-mobile');
            cellElement.textContent = cell;
            tableHead.appendChild(cellElement);
        });

        // get .lookeen__price-comparison-table-body 
        const priceComparisonTableBody = document.querySelector('.lookeen__price-comparison-table-body');
        //  lookeen__price-comparison-table-row-heading inside priceComparisonTableBody
        const priceComparisonTableRowHeadings = priceComparisonTableBody.querySelectorAll('.lookeen__price-comparison-table-row-heading');
        console.log(priceComparisonTableRowHeadings);

        // append tableHead next to all priceComparisonTableRowHeadings

        priceComparisonTableRowHeadings.forEach(heading => {
            const tableHeadClone = tableHead.cloneNode(true); // Create a copy
            heading.insertAdjacentElement('afterend', tableHeadClone);
        });
    }


    // function removeTableMobileColumnHeadings(){
    //     if(!mobileColumnHeadingAdded) return;
    //     mobileColumnHeadingAdded = false;
    //     const tableHeadMobile = document.querySelector('.lookeen__price-comparison-table-head-mobile');
    //     if(tableHeadMobile) {
    //         tableHeadMobile.remove();
    //     }
    // }



});